import React from 'react';

import ResponsiveImage from '@/components/utility/ResponsiveImage/ResponsiveImage';
import { IOdnMedia } from '@/services/types/search/rentals/id';
import { getYoutubeVideoId } from '@/utility/youtubeParser';

type TLightboxMediaProps = {
  url: string;
  alt?: string;
  isVideo?: boolean;
  odnMedia?: IOdnMedia;
};

export const LightboxMedia = ({ url, alt, isVideo, odnMedia }: TLightboxMediaProps) => {
  if (odnMedia?.is360Tour) {
    return (
      <div className="flex justify-center">
        <iframe
          title="kuula"
          width="70%"
          height="640"
          allow="xr-spatial-tracking; gyroscope; accelerometer"
          allowFullScreen
          src={`${odnMedia.url}?fs=0&vr=1&zoom=1&alpha=0.75&hideinst=1&chromeless=1&logo=false"`}
          className="overflow-hidden border-none"
        />
      </div>
    );
  }

  if (isVideo || odnMedia?.isVideo) {
    return (
      <div className="relative w-full max-h-full overflow-hidden aspect-video">
        <iframe
          title={alt}
          allow="autoplay; encrypted-media"
          allowFullScreen
          src={`https://www.youtube.com/embed/${getYoutubeVideoId(odnMedia?.url || url)}?enablejsapi=1&output=embed`}
          className="w-full h-full overflow-hidden border-none"
        />
      </div>
    );
  }

  return (
    <ResponsiveImage
      src={url}
      alt={alt}
      sourceSizes={['landscape1440']}
      cropMode="fit"
      className="object-contain w-full max-h-full"
    />
  );
};
